import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { DOCS_KEY } from '../api';

/** ניהול נהלים (PRD 5.10.1). העלאת הגרסה נעשית בטריגר בשרת. */
export function useDocCategories() {
  return useQuery({
    queryKey: ['doc-categories'],
    staleTime: 10 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('doc_categories')
        .select('id, name')
        .order('sort_order');
      if (error) throw error;
      return data ?? [];
    },
  });
}

export function useDocumentMutations() {
  const queryClient = useQueryClient();
  const refresh = () => {
    void queryClient.invalidateQueries({ queryKey: DOCS_KEY });
    void queryClient.invalidateQueries({ queryKey: ['notifications'] });
  };

  /**
   * הכותרת, התוכן והקטגוריות נשמרים יחד (מיגרציה 083).
   *
   * פעולה אחת ולא שתיים: שמירה שהצליחה חלקית היתה מעלה גרסה,
   * מבקשת מכל העובדים לחתום מחדש, ומשאירה את הנוהל בקטגוריה הלא
   * נכונה.
   */
  const save = useMutation({
    mutationFn: async (input: {
      id?: string;
      title: string;
      categoryIds: string[];
      body: string | null;
      requiresSignature: boolean;
      isPublished: boolean;
    }) => {
      const { error } = await supabase.rpc('save_document', {
        p_title: input.title,
        p_categories: input.categoryIds,
        p_body: input.body ?? undefined,
        p_requires_signature: input.requiresSignature,
        p_is_published: input.isPublished,
        p_id: input.id,
      });
      if (error) throw error;
    },
    onSuccess: refresh,
  });

  const remove = useMutation({
    mutationFn: async (id: string) => {
      const { error } = await supabase.from('documents').delete().eq('id', id);
      if (error) throw error;
    },
    onSuccess: refresh,
  });

  return { save, remove };
}
